import React, { useState } from "react";
import useStyles from './ProfileSideBarCss';
import { SideBarData } from './ProfileSideBarData';
import { withRouter, useHistory, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import SidebarItem from '../Sidebar/SidebarItem';
import { ListItem, ListItemIcon, Typography, ListItemAvatar, ListItemText } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import ComingSoonModal from '../ComingSoonModal/comingSoonModal';
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { logoutUser,resetPayment } from "../../../store/actions/authActionCreators";
import { DialogTitle, Dialog, DialogContent, Divider, IconButton, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { ProfitLossIcon, SupplierBalanceReportIcon, PartyBalanceReportIcon } from '../../../components/icons';
import ReportsDialog from '../ReportsDialog/ReportsDialog';
import { trackDwebEvent,loginDwebEvent,logoutDwebEvent } from '../../analytics';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const SideBar = ({ location,user, dispatchLogoutAction,dispatchPaymentReset,payments }) => {

    const [comingSoonModalOpen, setComingSoonModalOpen] = useState(false);
    const [featureNameIn, setFeatureNameIn] = useState("");

    const classes = useStyles();
    let history = useHistory();

    const handleProfileSideBar = (link) => {
        if (link == "Diesel Prices" || link == "Bank Accounts" || link == "Security & Backup") {
            setFeatureNameIn(link);
            setComingSoonModalOpen(true);
        }
    }

    const handleClose = () => {
        setComingSoonModalOpen(false);
    }

    const handleLogOut = () => {
        logoutDwebEvent(user && user.userInfo?user.userInfo:{})
        dispatchPaymentReset();
        dispatchLogoutAction();
    }

    return (
        <>
            <div className={payments && payments.freeTrial && payments.freeTrial===true?classes.sideBarV2:payments && payments.subscriptionStatus 
      && payments.subscriptionStatus.status && 
      payments.subscriptionStatus.subscriptionType
      && payments.subscriptionStatus.orderId
      && payments.subscriptionStatus.status=="PROCESSING"?classes.sideBarV2:classes.sideBarV1}>
                {/* <ul className={classes.sideBarList}>
                    {SideBarData.map((val, key) => {
                        return (
                            <li key={key} id={window.location.pathname == val.link ? "active" : ""} className={classes.row} onClick={() => { handleNav(val.link) }}>
                                <div>{val.icon}</div>
                                <div>{val.title}</div>
                            </li>
                        );
                    })}
                </ul> */}
                <List component="div" className={classes.menuList}>
                    {SideBarData.map((route, index) => {
                        let isCurrentPath =
                            location && location.pathname.indexOf(route.path) > -1 ? true : false;
                        return (
                            <NavLink
                                to={{
                                    pathname: route.path,
                                    state: route.state ? route.state : {}
                                }}
                                exact
                                className={classes.menuLink}
                                activeClassName={classes.menuActive}
                                key={index}
                            >
                                <ListItem
                                    className={classes.menuItem}
                                    button
                                    onClick={() => handleProfileSideBar(route.name)}
                                >
                                    <ListItemIcon className={classes.liV1}>
                                        {route.icon}
                                    </ListItemIcon>
                                    <Typography variant="body1" className={classes.mtV2}>
                                        {route.name}
                                    </Typography>
                                </ListItem>
                            </NavLink>
                        );
                    })}
                </List>

                <List className={classes.marginTopV1} onClick={() => handleLogOut()}>
                    <ListItem button className={classes.listItemLogout}>
                        <div className={classes.divLogoutOuter}>
                            <div className={classes.divLogoutInner}>
                                <ExitToAppIcon />
                                <div className={classes.divLogout}>Logout</div>
                            </div>
                        </div>
                    </ListItem>
                </List>
            </div>

            {comingSoonModalOpen && <ComingSoonModal open={comingSoonModalOpen} onClose={handleClose} featureName={featureNameIn} />}

        </>
    );
}

// export default withRouter(SideBar);

const mapStateToProps = (state) => ({ 
    user: state.user, 
    vehicle: state.vehicle,
    payments:state.payments
});
const mapDispatchToProps = (dispatch) => ({
    dispatchPaymentReset: () => dispatch(resetPayment()),
    dispatchLogoutAction: () => dispatch(logoutUser()),
});

const SideBarWithRouter = withRouter(SideBar);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SideBarWithRouter);